import type * as Blockly from 'blockly/core';
import { expr, registerSetupCode, resolveAnalogPin } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['soil_moisture_c'] = function (block: Blockly.Block): [string, number] {
        const { pin, config } = resolveAnalogPin(block);
        const maxValue = gen.valueToCode(block, 'MAX_VALUE', 0) || '1000';

        registerSetupCode(pin, `  pinMode(${pin}, INPUT);\n`);

        const minExpr =
            config.analogRes === 4095
                ? `(int)(min(analogRead(${pin}), (uint16_t)${maxValue}) / (float)${maxValue} * 100)`
                : `(int)(min(analogRead(${pin}), ${maxValue}) / (float)${maxValue} * 100)`;

        return expr(minExpr);
    };
}
